import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/auth';

import { Container, Thead, Head, Footer, HeaderMobile, AvatarsContainer2, Medal } from './styles';

import AvatarProgress from '../AvatarProgress';
import { CaretDown } from 'phosphor-react';
import api from '../../services/api';
import LoaderSpinner from '../LoaderSpinner';
import TooltipAdapter from '../TooltipAdapter';
import { FiInfo } from 'react-icons/fi';
import { API_S3 } from '../../services/api_s3';

type IRankingFilterProps = 'month' | 'year';

export interface IRankingProps {
  ranking: {
    points: number;
    position: number;
    user: {
      id: string;
      show_name: string;
      avatar_url: string;
      exp: number;
      level: number;
      next_level: number;
    };
  }[];
  profileRanking: {
    points: number;
    position: number;
  };
}

const CardRanking: React.FC = () => {
  const { user } = useAuth();
  const [rankingFilter, setRankingFilter] =
    useState<IRankingFilterProps>('year');
  const [loading, setLoading] = useState(false);

  const [rankingData, setRankingData] = useState<IRankingProps>(
    {} as IRankingProps,
  );

  const IS_MOBILE_OR_TABLET = window.innerWidth < 1024;

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await api.get(`/users/ranking`, {
          params: {
            filter: rankingFilter,
          },
        });
        console.log(response.data);
        setRankingData(response.data);
      } catch (error) {
        console.log(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    })();
  }, [rankingFilter]);

  return (
    <Container>
      {loading && <LoaderSpinner zIndex={99999} />}
      {rankingData && rankingData.ranking && rankingData.ranking.length > 0 && (
        <>
          {!IS_MOBILE_OR_TABLET && (
            <header>
              <Head>
                <TooltipAdapter
                  alt="As estatísticas do ranking  são <br />atualizadas diariamente. ⏰"
                  place="top"
                  cursor="help"
                >
                  <FiInfo strokeWidth={2.5} size={20} />
                </TooltipAdapter>
                <main>
                  <select
                    onChange={e =>
                      setRankingFilter(e.target.value as IRankingFilterProps)
                    }
                    defaultValue={rankingFilter}
                  >
                    <option value="year">
                      Este ano
                    </option>
                    <option value="month">
                      Este mês
                    </option>
                  </select>
                  <CaretDown weight="duotone" />
                </main>
              </Head>

              <AvatarsContainer2>
                <main>
                  <div>
                    <TooltipAdapter alt={`TOP #2: ` + rankingData?.ranking[1]?.user.show_name} place="top">
                      <AvatarProgress
                        size={80}
                        url={rankingData?.ranking[1]?.user.avatar_url}
                        percent={rankingData?.ranking[1]?.user.next_level || 0}
                        badgeValue={rankingData?.ranking[1]?.user.level}
                      />
                      <Medal><img src={`${API_S3}/default/22-ranking.png`} alt={rankingData?.ranking[1]?.user.show_name} /></Medal>
                    </TooltipAdapter>
                    <footer>
                      <h2>{rankingData?.ranking[1]?.user.show_name.split(' ')[0]} {(rankingData?.ranking[1]?.user?.show_name.split(' ')[1] ? rankingData?.ranking[1]?.user?.show_name.split(' ')[1][0] + '.' : '').toUpperCase()}</h2>
                      <h3>
                        {rankingData?.ranking[1]?.points} <span>pontos</span>
                      </h3>
                    </footer>
                  </div>
                  <div>
                    <TooltipAdapter alt={`TOP #1: ` + rankingData?.ranking[0]?.user.show_name} place="top">
                      <AvatarProgress
                        size={80}
                        url={rankingData?.ranking[0]?.user.avatar_url}
                        percent={rankingData?.ranking[0]?.user.next_level || 0}
                        badgeValue={rankingData?.ranking[0]?.user.level}
                      />
                      <Medal><img src={`${API_S3}/default/11-ranking.png`} alt={rankingData?.ranking[1]?.user.show_name} /></Medal>
                    </TooltipAdapter>
                    <footer>
                      <h2>{rankingData?.ranking[0]?.user.show_name.split(' ')[0]} {(rankingData?.ranking[0]?.user?.show_name.split(' ')[1] ? rankingData?.ranking[0]?.user?.show_name.split(' ')[1][0] + '.' : '').toUpperCase()}</h2>
                      <h3>
                        {rankingData?.ranking[0]?.points} <span>pontos</span>
                      </h3>
                    </footer>
                  </div>
                  <div>
                    <TooltipAdapter alt={`TOP #3: ` + rankingData?.ranking[2]?.user.show_name} place="top">
                      <AvatarProgress
                        size={80}
                        url={rankingData?.ranking[2]?.user.avatar_url}
                        percent={rankingData?.ranking[2]?.user.next_level || 0}
                        badgeValue={rankingData?.ranking[2]?.user.level}
                      />
                      <Medal><img src={`${API_S3}/default/33-ranking.png`} alt={rankingData?.ranking[1]?.user.show_name} /></Medal>
                    </TooltipAdapter>
                    <footer>
                      <h2>{rankingData?.ranking[2]?.user.show_name.split(' ')[0]} {(rankingData?.ranking[2]?.user?.show_name.split(' ')[1] ? rankingData?.ranking[2]?.user?.show_name.split(' ')[1][0] + '.' : '').toUpperCase()}</h2>
                      <h3>
                        {rankingData?.ranking[2]?.points} <span>pontos</span>
                      </h3>
                    </footer>
                  </div>
                </main>
              </AvatarsContainer2>
            </header>
          )}

          {IS_MOBILE_OR_TABLET && (
            <HeaderMobile>
              <div>
                <h2>Ranking {rankingFilter === 'year' ? 'anual' : 'mensal'}</h2>
                <main>
                  <select
                    onChange={e =>
                      setRankingFilter(e.target.value as IRankingFilterProps)
                    }
                    defaultValue={rankingFilter}
                  >
                    <option value="year">
                      Este ano
                    </option>
                    <option value="month">
                      Este mês
                    </option>
                  </select>
                  <CaretDown weight="duotone" />
                </main>
              </div>
            </HeaderMobile>
          )}
          <Thead>
            <div>
              <h5>#</h5>
              <h5>Aluno</h5>
              <h5>Pontos</h5>
              <h5>Level</h5>
            </div>
          </Thead>
          <main>
            {IS_MOBILE_OR_TABLET ? (
              <>
                {rankingData?.ranking.slice(0, 10).map((ranking, index) => (
                  <div key={index}>
                    <h5>{ranking.position}</h5>
                    <div>
                      <AvatarProgress
                        badgeValue={ranking.user.level}
                        percent={ranking.user.next_level}
                        url={ranking.user.avatar_url}
                        size={40}
                      />
                      <h5>{ranking?.user?.show_name}</h5>
                    </div>
                    <h5>{ranking.points}</h5>
                    <h5>{ranking?.user?.level}</h5>
                  </div>
                ))}
              </>
            ) : (
              rankingData?.ranking.slice(3, 10).map((ranking, index) => (
                <div key={index}>
                  <h5>{ranking.position}</h5>
                  <div>
                    <AvatarProgress
                      badgeValue={ranking.user.level}
                      percent={ranking.user.next_level}
                      url={ranking.user.avatar_url}
                      size={40}
                    />
                    <h5>{ranking?.user?.show_name.split(' ')[0]}</h5>
                  </div>
                  <h5>{ranking.points}</h5>
                  <h5>{ranking?.user?.level}</h5>
                </div>
              ))
            )}
          </main>
          <Footer>
            <div>
              <h5>{rankingData?.profileRanking?.position}</h5>
              <div>
                <AvatarProgress
                  badgeValue={user.level}
                  percent={user.current_exp}
                  url={user.avatar_url}
                  size={40}
                />
                <h5>Você</h5>
              </div>
              <h5>{rankingData?.profileRanking.points}</h5>
              <h5>{user.level}</h5>
            </div>
          </Footer>
        </>
      )}
    </Container>
  );
};

export default CardRanking;
